<template>
    <span class="state"
        :class="[props.state.toLowerCase()]"
        :title="t(`state.default.code.${ props.state.toLowerCase() }`)"
    >
        <Icon :icon="`workflow-${ props.state.toLowerCase() }`" />
        <span>{{ t(`state.default.code.${ props.state.toLowerCase() }`) }}</span>
    </span>
</template>

<script setup>
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();

    const props = defineProps({
        state: { type: [String, null], default: null }
    });
</script>

<style lang="scss" scoped>
    .state {
        @include state;
    }
</style>
